// Module
var code = `<form name="\$ctrl.form">

  <custom-fee-edit
    ng-if="\$ctrl.selectedFeeForEdit"
    fee="\$ctrl.selectedFeeForEdit"
    all-fee-definitions="\$ctrl.feeDefinitions"
    product-group="\$ctrl.productGroup"
    product-config="\$ctrl.productConfig"
    on-save="\$ctrl.save()"
    on-cancel="\$ctrl.cancelFeeDefinitionEdition()">
  </custom-fee-edit>

  <div ng-if="!\$ctrl.selectedFeeForEdit">
    <table class="table table--generate-row-ids">
      <thead>
        <tr>
          <th>No.</th>
          <th>Name</th>
          <th>Values</th>
          <th ng-if="\$ctrl.productGroup === 'LOAN'">Calculation Order</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="feeDefinition in \$ctrl.feeDefinitions">
          <td></td>
          <td>{{feeDefinition.feeName}}</td>
          <td ng-if="feeDefinition.feeType === 'FIXED' || (feeDefinition.feeType === 'ARBITRARY' && feeDefinition.calculationMethod === 'FIXED_AMOUNT')">
            {{feeDefinition.fixedAmount | nxCurrency}}
          </td>
          <td ng-if="feeDefinition.feeType === 'PERCENTAGE' || (feeDefinition.feeType === 'ARBITRARY' && feeDefinition.calculationMethod !== 'FIXED_AMOUNT')">
            {{feeDefinition.percentageAmount}}% {{feeDefinition.calculationMethod ? "(" + \$ctrl.formatCalculationMethod(feeDefinition.calculationMethod) + ")" : ''}}
          </td>
          <td ng-if="feeDefinition.feeType === 'FORMULA'">{{feeDefinition.formula}}</td>
          <td ng-if="\$ctrl.productGroup === 'LOAN'">
            {{feeDefinition.feeType === 'FORMULA' ? feeDefinition.calculationOrder : undefined}}
          </td>
          <td class="table__actions">
            <button type="button" class="btn btn-warning"
                                  ng-click="\$ctrl.editFeeDefinition(feeDefinition)">
              Edit
            </button>
            <button type="button" class="btn btn-danger" ng-if="(feeDefinition.feeClass === 'CUSTOM') || (\$ctrl.productGroup === 'DEPOSIT' && feeDefinition.feeClass === 'DOC_STAMP')"
                                  ng-click="\$ctrl.removeFeeDefinition(\$index)">
              Remove
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td ng-if="\$ctrl.productGroup === 'LOAN'"></td>
          <td>
            <button type="button" class="btn btn-primary" ng-click="\$ctrl.addNewFeeDefinition()">
              Add new fee
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/charge/custom-fee-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;